
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthHttpInterceptor, AuthModule, AuthService } from '@auth0/auth0-angular';
import { NavigationComponent } from '../navigation/navigation.component';
import { AuthorizationComponent } from './authorization.component';
import { AuthHttpInterceptorExtended } from './authorization-interceptor';
import { FeatureToggleGuard } from '../services/guards/feature-toggle.guard';
import { InvalidAuthorizationComponent } from './invalid-authorization.component';
import { SharedModule } from '@Shared/shared.module';

const routes: Routes = [
    {
        path: 'authorize',
        component: AuthorizationComponent,
        canActivate: [FeatureToggleGuard],
        children: [
            { path: 'dashboard', component: NavigationComponent }
        ]
    },
    {
        path: 'invalid/:error',
        component: InvalidAuthorizationComponent
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        AuthModule.forRoot(),
        AuthorizationComponent, InvalidAuthorizationComponent
    ],
    exports: [AuthModule, RouterModule],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptorExtended, multi: true },
        {
            provide: AuthHttpInterceptor
        },
    ]
})
export class AuthorizationModule {
    static forRoot(): ModuleWithProviders<AuthorizationModule> {
        return {
            ngModule: AuthorizationModule,
            providers: [AuthService],
        };
    }
}
